const getAlignmentFromDirection = (direction) => direction.toLowerCase() === "rtl" ? "right" : direction.toLowerCase() === "ltr" ? "left" : void 0;
export {
  getAlignmentFromDirection
};
//# sourceMappingURL=utils.js.map
